import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProducts = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		clipRule: "evenodd",
		d: "M8.27 15.395a1.5 1.5 0 0 1-2.122.002l-3.211-3.21a1.5 1.5 0 0 1 0-2.122L8.35 4.652a1.667 1.667 0 0 1 1.18-.488h2.97c.92 0 1.667.747 1.667 1.668v2.966c0 .442-.175.866-.487 1.178l-5.41 5.42Z",
		stroke: "currentColor",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M17.503 6.665v3.166c0 .442-.176.866-.488 1.18l-4.72 4.72",
		stroke: "currentColor",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgProducts;
